import { render } from "./BaseSpinner.vue?vue&type=template&id=4dd70610&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=4dd70610&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd70610"]])

export default __exports__